module.exports = __webpack_public_path__ + "static/media/Braised_Eggplant.26d074e2.webp";